/* eslint-disable react/button-has-type */
import React, { useEffect, useRef, useState } from 'react'
import classnames from 'classnames'
import Dropdown from '../../baseComponent/tempDropdown'
import Empty from '../../image/empty.png'
import request from '../../utils/request'
import * as image from '../../utils/image'
import Icon from '../icon'
import CreateIdeaMass from '../createIdeaMass'
import { NewSearch } from '../../baseComponent/input'
import './index.less'

const getInsList = params => request.spost(`/zhikuan/ins/inspiration/list-simple-inspiration?pageSize=${500}`, params, 'getInspirationListx')

const Input = (props) => {
  const { crtTab = {}, callback, value = '', inputStyle, maxLength = 30 } = props
  const { placeholder, searchKey } = crtTab
  const [isFocus, setFocus] = useState(value)
  return (<span>
    {/* <Icon type="m-sousuo" /> */}
    <NewSearch
      value={value}
      maxLength={maxLength}
      className={classnames({ focus: isFocus })}
      onChange={e => callback(e, searchKey)}
      onClear={e => callback(e.target.value, searchKey)}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(!!value)}
      placeholder={isFocus ? placeholder : '搜索'}
      style={inputStyle}
    />
  </span>)
}

export default ({ unionId, inspirationId, onRemove, onChange, onJoin, style, multiple = true }) => {
  const [insList, setInsList] = useState([])
  const [keyWords, setKeyWords] = useState('')
  const [visible, setVisible] = useState(false)
  const [selected, setSelected] = useState([])
  const isMount = useRef(false)

  useEffect(() => {
    getList()
  }, [keyWords])
  useEffect(() => {
    if (selected?.length) {
      onChange?.(selected?.map(m => m?.id), selected)
    }
  }, [selected])
  const getList = async () => {
    try {
      const list = await getInsList({ queryType: 3, rankStatus: -3, likeName: keyWords, blogId: unionId })
      if (!isMount.current) {
        isMount.current = true
        let _selected = []
        if (unionId) {
          _selected = list.resultList?.filter(m => m.currentFlag)
        }
        if (inspirationId) {
          const res = list.resultList.find(m => m.id === inspirationId)
          _selected = [res]
        }
        if (_selected.length === 0) {
          _selected = [list.resultList?.[0]]
        }
        setSelected(_selected)
      }
      setInsList(list.resultList || [])
    } catch (error) {
      console.error(error)
    }
  }

  const onJoinIns = async (ins) => {
    const _selected = [...selected, ins]
    setSelected(_selected)
    await onJoin?.(ins)
  }
  const onClick = (ins) => {
    setSelected([ins])
    setVisible(false)
  }
  const onRemoveIns = async (ins) => {
    const _selected = selected.filter(m => m.id !== ins.id)
    setSelected(_selected)
    await onRemove?.(ins)
  }
  const onCreateInspiration = async (_insId, params) => {
    await getList()
    if (multiple) {
      await onJoinIns?.(params)
    } else {
      await onClick(params)
    }
  }
  const content = <div className="mn-upload-ins-ins-list-content">
    <Input
      value={keyWords}
      crtTab={{ placeholder: '搜索' }}
      callback={e => setKeyWords(e)}
      inputStyle={{ width: '100%' }}
      maxLength={10000}
    />
    <ul className="mn-upload-ins-inspiration-list">
      {insList.map((item, index) => (
        <li key={index} className={classnames('mn-upload-ins-inspiration-group', { 'list-item-select': !multiple })} onClick={() => !multiple && onClick(item)}>
          <div className="list-left">
            <div className="item-cover" style={{ background: `url(${image.ossImg(item?.coverImgUrl || item?.lastBlogList?.[0]?.mainUrl, 64)}) center/cover no-repeat` }}>
              { item.cooperation
                ? <div className="item-covor-private-icon">
                  <Icon type="m-tuandui_xiao" style={{ fontSize: '14px' }} />
                </div>
                : null }
              { (item.coverImgUrl || (item.lastBlogList && item.lastBlogList[0])) ? null
                : <img className="item-cover-empty-icon" src={Empty} alt="" />}
            </div>
            <span className="item-title">
              {item.name}
              <div className="item-username">by&nbsp;{item.userName}</div>
            </span>
          </div>
          {multiple && <div className="upload-list-right">
            {selected.some(m => m.id === item.id)
              ? <button type="button" className="upload-list-right-remove" onClick={() => onRemoveIns(item)}>
                <Icon className="collected" type="m-jianshao_miaobian" />
              </button>
              : <button type="button" className="mn-upload-list-right-collect" onClick={() => onJoinIns(item)}>
                <Icon type="m-tianjia_miaobian" />
              </button>}
          </div>}
        </li>
      ))}
    </ul>
    <CreateIdeaMass
      onChange={(insId, model) => onCreateInspiration(insId, model)}
    >
      <a className="mn-inspiration-footer-create" onClick={() => setVisible(false)}>+&ensp;创建灵感集</a>
    </CreateIdeaMass>
  </div>

  return <Dropdown
    trigger="click"
    position="bottom"
    // overlayClassName="mn-upload-ins-inslist-overlay"
    overlay={content}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
  >
    <div style={{ display: 'flex', ...style }}>
      <div className="mn-upload-ins-inslist">
        {selected.length > 1 ? <>已加入<i style={{ fontWeight: 500 }}>{selected.length}个灵感集</i></> : selected[0]?.name}
      </div>
      <div className="mn-upload-ins-inslist-icon">
        <Icon type="m-Vxing_xia" />
      </div>
    </div>
  </Dropdown>
}
